import { render, staticRenderFns } from "./topBanner.vue?vue&type=template&id=6aba503b&scoped=true&"
import script from "./topBanner.vue?vue&type=script&lang=ts&"
export * from "./topBanner.vue?vue&type=script&lang=ts&"
import style0 from "./topBanner.vue?vue&type=style&index=0&id=6aba503b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aba503b",
  null
  
)

export default component.exports